import type { NetworkType, PolicyType } from '@mls-wallet/shared-types';

type PolicyFormValidationState = {
  policyName: string;
  policyType: PolicyType;
  networkId: NetworkType | null;
  selectedApprover: unknown | null;
};

export function isPolicyFormSubmittable(
  data: PolicyFormValidationState | null
): boolean {
  // Case: No form data yet.
  if (!data) return false;

  // Required: Policy must have a name.
  if (!data.policyName.trim()) return false;

  // Required: Network must be selected.
  if (!data.networkId) return false;

  // Required: Approver must be selected for manual approval policies.
  if (data.policyType === 'MANUAL_APPROVAL' && !data.selectedApprover) {
    return false;
  }

  return true;
}
